import styled, { css } from 'styled-components';

import { CONTAINER_PADDING } from '@components/blocks/blocks.constants';
import { media } from '@theme/media';
import { COLORS } from '@theme/colors';
import { FONT_SIZE, LETTER_SPACING, typography } from '@theme/font';
import { blurredTransparentHeaderBackgroundStyles } from '@components/header/header.styles';
import { OFFSET } from '@theme/helpers';

export const Container = styled.div`
  padding-top: ${CONTAINER_PADDING * 3}px;
`;

export const ContainerInner = styled.div`
  padding-bottom: ${CONTAINER_PADDING * 3}px;
`;

export const ContainerNarrow = styled.div`
  max-width: 710px;
  margin: 0 ${OFFSET.S};

  ${media.tablet} {
    margin: 0 auto;
  }
`;

export const ProductsContainer = styled.div`
  margin: ${OFFSET.XS} ${OFFSET.XS} 0;

  ${media.tablet} {
    margin: ${OFFSET.S} ${OFFSET.S} 0;
  }
`;

export const ArtistsLinksContainer = styled.div`
  margin: ${OFFSET.M};

  ${media.tablet} {
    display: flex;
    gap: ${OFFSET.M};
  }
`;

export const ArtistLinkContent = styled.span`
  padding-bottom: 1px;
  border-bottom: 1px solid transparent;
  text-align: center;
`;

export const ArtistLink = styled.a`
  ${typography({ size: FONT_SIZE.L })};
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1 1 0;
  padding: 54px 0 1px;
  line-height: 1;
  text-transform: uppercase;

  &:first-of-type {
    border-top: 1px solid black;
  }

  &:hover ${ArtistLinkContent}:last-of-type {
    border-color: black;
  }

  ${media.tablet} {
    ${typography({ size: FONT_SIZE.L })};
    border-top: 1px solid black;
  }
`;

export const MenuContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 13px;
  height: 44px;
  border-top: 1px solid ${COLORS.BLACK10};
  ${blurredTransparentHeaderBackgroundStyles}

  ${media.tablet} {
    height: 51px;
  }
`;

const menuButtonStyles = css`
  ${typography({ spacing: LETTER_SPACING.M })};
  padding: 9px ${OFFSET.XS};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${media.tablet} {
    padding: 9px 20px;
  }
`;

export const MenuOption = styled.div`
  ${menuButtonStyles};
`;
